// @flow

import React, { type Node } from 'react';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { useFieldMetadata } from '@tectonics/prs/form';
import { Captcha } from '@tectonics/captcha/components';
import { useIncomingPayment, getRecaptchaSiteKey } from '@tectonics/prs/incoming-payment';
import { SimpleTextErrorMessage } from '@tectonics/look-and-feel/commons/validation-error-message';
import { useAutoResetCaptcha } from '@tectonics/captcha';
import { TextBlock } from '../../../atoms';

export function FieldCaptchaToken(): Node {
  const [, handleChange] = useUserInputValue('captchaToken');
  const { validationError, formHasBeenSent } = useFieldMetadata('captchaToken');
  const incomingPayment = useIncomingPayment();
  const siteKey = getRecaptchaSiteKey(incomingPayment);
  const shouldResetCaptcha = useAutoResetCaptcha();

  return (
    <div style={{ marginTop: '1em' }} data-error={formHasBeenSent && validationError ? 'error' : null}>
      <Captcha siteKey={siteKey} setCaptchaToken={handleChange} shouldResetCaptcha={shouldResetCaptcha} />
      {validationError && formHasBeenSent && (
        <TextBlock flavor="error">
          <SimpleTextErrorMessage validationError={validationError} getMessage={getMessage} />
        </TextBlock>
      )}
    </div>
  );
}

function getMessage(): string {
  return 'Resolva o desafio Captcha';
}
